// Company status (as defined in backend model)
export const COMPANY_STATUS_PRIVATE = 1;
export const COMPANY_STATUS_PUBLIC = 2;
